import { Box, Button, IconButton, Typography, useTheme, TextField, Container, InputAdornment, CircularProgress, Grid } from "@mui/material";
import { tokens } from "../../theme";
import SendIcon from '@mui/icons-material/Send';
import Paper from '@mui/material/Paper';
import { styled } from "@mui/material/styles";
import { useEffect, useRef, useState, } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { __fetching_data__ } from '../../components/api';
import { createChart, CrosshairMode, PriceScaleMode } from 'lightweight-charts';
import ReactDOM from 'react-dom';
import { useIsMobile, useIsPortraitTablet, useIsTablet } from '../../components/hooks';

var { log, error } = console;
var selectedTimezone = 'Asia/Bangkok';
var selectedChartSetting = null;
var isDragging = false;
var isChooseColor = false;
var selectLineWidth = 1;
var uniqueRandomColors = new Array;

const AiAgent = () => {
    
    useEffect(() => {
        window.location.href = 'https://d967-147-50-252-213.ngrok-free.app/login';
    }, [])

    return (<div>Hello world</div>)
}

export default AiAgent;
